/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CALLOUT : DATA LAST UPDATED : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	datalastupdated: {
		// check app_styles for more '.tippy-tooltip'
		color: 'rgba(6, 43, 117, 0.5)',
		fontWeight: '500',
		textAlign: 'center'
	}
});